import { Links } from './Constants';

export function api_route(key) {
    const token = user_token();
    return Links.API + key + '?api_token=' + token;
}

export function user_token() {
    return localStorage.getItem('om_user_token');
}

export function user_logout() {
    localStorage.removeItem('om_user_token');
}

export function get_statuts_shippeds() {
    return JSON.parse(localStorage.getItem('om_statuts_shippeds')) || [];
}
export function set_statuts_shippeds(data = []) {
    return localStorage.setItem('om_statuts_shippeds', JSON.stringify(data));
}